export default "__VITE_ASSET__DCVlByfL__"